<template>
    <div>
        <b-table
            show-empty
            empty-text="ไม่มีรายละเอียดข้อมูลร้าน"
            :items="brance"
            :fields="fieldsBrance"
            responsive
            :busy="busy"
            class="scroll-bar-pop"
        >
            <div slot="table-busy" class="text-center">
                <BlockUI >
                    <div class="loader"></div>
                </BlockUI>
            </div>
            <template slot="status" slot-scope="row">
                <div class="switch-brance">
                    <b-form-checkbox
                        v-model="row.item.status"
                        name="check-button"
                        value="1"
                        unchecked-value="0"
                        @change="$emit('statusChange',row.item.status , row.item.id)"
                        switch
                    ></b-form-checkbox>
                </div>
            </template>
            <template slot="shop_code" slot-scope="row">
                <span>{{row.item.shop_code}}</span><br>
                <span>{{row.item.owner_name}}</span><br>
                <span>{{($THEME.packagePrefix) ? $THEME.packagePrefix[row.item.package] : row.item.package}}</span>
            </template>
            <template slot="name" slot-scope="row">
                <span>{{row.item.name}}</span><br>
                <span>{{row.item.tel}}</span>
            </template>
            <template slot="contract_date" slot-scope="row">
                <span v-if="row.item.contract_date == '-'">-</span>
                <span v-else>{{row.item.contract_date | dateFormat}}</span><br>
                <div v-if="row.item.expired_date == null">กรุณาเลือกแพ็กเกจ</div>
                <div v-else>{{ row.item.expired_date | dateFormat }}</div>
            </template>
            <template slot="latitude_shop" slot-scope="row">
                <a :href="`https://maps.google.com/?q=` + row.item.latitude_shop + `,` + row.item.longitude_shop" target="_blank" v-if="row.item.latitude_shop != '-'" class="text-newline">
                    {{`https://maps.google.com/?q=` + row.item.latitude_shop + `,` + row.item.longitude_shop}}
                </a>
                <span v-else>-</span>
            </template>
            <template slot="service_area_condition" slot-scope="row">
                <span>{{serviceAreaBrance(row.item.service_area_condition)}}</span>
            </template>
            <template slot="address" slot-scope="row">
                <span class="text-newline">{{row.item.address}}</span>
            </template>
            <template slot="address_eng" slot-scope="row">
                <span class="text-newline">{{row.item.address_eng}}</span>
            </template>
            <template slot="closed_day" slot-scope="row">
                <template v-if="row.item.closed_day != '-'">
                    <div v-for="(day,index) in row.item.closed_day" :key="index">
                        {{dayBrance(Object.keys(day)[0])}} {{day[Object.keys(day)].open}} - {{day[Object.keys(day)].close}} น.
                    </div>
                </template>
                <span v-else>-</span>
            </template>
            <template slot="location_near" slot-scope="row">
                <template v-if="row.item.location_near != '-'">
                    <div v-for="(place,index) in row.item.location_near" :key="index">
                        <span>{{locationBrance(Object.keys(place)[0])}}</span><br>
                        <span class="text-muted">{{place[Object.keys(place)]}}</span>
                    </div>
                </template>
                <span v-else>-</span>
            </template>
            <template slot="actions" slot-scope="row">
                <button
                    class="btn btn-sm btn-info px-3"
                    @click="$router.push({name:'branceedit',params:{Id:row.item.id}})"
                >แก้ไข</button>
                <button
                    class="btn btn-sm btn-danger px-3"
                    @click="($emit('showComfirmModal',row.item.id))"
                    v-if="auth0RoleUsage('brancemanagedelete')"
                >ลบ</button>
            </template>
        </b-table>
    </div>
</template>
<script>
import moment from "moment"
import { dayBrance , locationBrance , serviceAreaBrance } from "@/plugins/formatForBrance.js";
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
    name:"TableBranceUpgrade",
    props: {
        busy: Boolean,
        brance: Array,
    },
    data(){
        return{
            dayBrance: dayBrance,
            locationBrance: locationBrance,
            serviceAreaBrance: serviceAreaBrance,
            auth0RoleUsage: auth0RoleUsage
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },
    },
    computed:{
        fieldsBrance(){
            let fields = [
                { key: "status", label: "สถานะ", sortable: true },
                { key: "last_updated", label: "วันที่อัพเดตข้อมูลล่าสุด", sortable: true },
                { key: "shop_code", label: "ร้าน", sortable: true , class: 'text-center'},
                { key: "name", label: "ชื่อ/เบอร์ร้าน", sortable: true },
                { key: "contract_date", label: "วันเซ็นสัญญา/วันหมดสัญญา", sortable: true },
                { key: "service_area_condition", label: "เงื่อนไขพื้นที่ให้บริการ", sortable: true },
                { key: "num_of_user", label: "จำนวนผู้ใช้", sortable: true },
                { key: "address", label: "ที่อยู่ (ภาษาไทย)", sortable: true },
                { key: "address_eng", label: "ที่อยู่ (ภาษาอังกฤษ)", sortable: true },
                { key: "latitude_shop", label: "พิกัดที่ตั้งร้าน", sortable: true },
                { key: "closed_day", label: "วันและเวลาเปิดทำการ", sortable: true },
                { key: "nature_business", label: "ลักษณะธุรกิจ", sortable: true },
                { key: "location_near", label: "สถานที่ใกล้ร้าน", sortable: true , class: 'text-center'},
                { key: "actions", label: "การจัดการ", sortable: true }
            ]
            return fields
        }
    }
   
}
</script>